export const EURformatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
});

export const ADAformatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'ADA',
});